import React from 'react'
import headerBanner from '../assets/images/header-bg.jpg'
import '../assets/css/Header.css';
import { ExpandMore } from '@material-ui/icons';
import { Link } from 'react-router-dom';


const Header = () => {
  return (
    <div className='header'>
        <img src={headerBanner} />
        <div className='banner-text'>
            <h1>Hero's Blog</h1>
        </div>
        <div className='banner__anchor'>
         <ExpandMore />
        </div>
    </div>
  )
}

export default Header
